module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA2CAYAAAB9TjFQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB7SURBVHgB7dWxDYAwDAVRBzEAo7ACG7AJK7Gp+TXKBJd7khUp3RWWR0fBbbUAIymWiNwzV3E8mbvIcijennAnKYykMJLCSAojKYykMJLCSAojKYykMJLCSAojKYykMJLCSAojKYykMJLCSAojKYykMJJiFEh3n3mO//8HOCcgLYxNciEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/scan-code/img/top-right.png
// module id = 1101
// module chunks = 0